import { Component } from '@angular/core';

@Component({
  selector: 'app-search',
  template: `
                <div>
                    <router-outlet></router-outlet>
                </div>
             ` ,
})

export class SearchComponent {

}
